module.exports = __webpack_public_path__ + "img/chart-go-get-links.aeb87df.svg";